import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { useCallback, useEffect, useState } from "react";
import { localStorage } from "@catchoftheday/utilities";
import { RECENT_SEARCH_TERMS_KEY, SEARCH_SUGGESTION_INDEX_NAME } from "../../../consts";
import { RecentSearchTerms } from "../../../pure/SearchBar/RecentSearchTerms/RecentSearchTerms";
import { SearchSuggestions } from "../../../pure/SearchBar/SearchSuggestions/SearchSuggestions";
import { getSuggestedSearchTerms, getTrendingSearchTerms } from "../../../utilities/searchBar/getSearchTermsFromSection";
import { jsx as ___EmotionJSX } from "@emotion/react";

function renderSearchSuggestions(autocompleteItems, getItemProps, getSectionProps) {
  return ___EmotionJSX(SearchSuggestions, _extends({
    data: autocompleteItems.data,
    getItemProps: getItemProps,
    title: autocompleteItems.displayName || autocompleteItems.indexSectionName || SEARCH_SUGGESTION_INDEX_NAME
  }, getSectionProps(autocompleteItems)));
}

export var SearchTermsContainer = function SearchTermsContainer(_ref) {
  var autocompleteItems = _ref.autocompleteItems,
      getItemProps = _ref.getItemProps,
      getSectionProps = _ref.getSectionProps;

  var _useState = useState([]),
      recentSearchTerms = _useState[0],
      setRecentSearchTerms = _useState[1];

  var getRecentSearches = useCallback(function () {
    var storedSearches = localStorage.getItem(RECENT_SEARCH_TERMS_KEY) || "[]";
    var storedSearchesArray = JSON.parse(storedSearches).filter(Boolean);

    if (storedSearchesArray.length) {
      var terms = storedSearchesArray.map(function (recentSearch) {
        if (typeof recentSearch !== "string") {
          return recentSearch.term;
        } else {
          return recentSearch;
        }
      });
      setRecentSearchTerms(terms);
    }
  }, []);

  function clearAll() {
    localStorage.removeItem(RECENT_SEARCH_TERMS_KEY);
    setRecentSearchTerms([]);
  }

  function clearItem(termToRemove) {
    var remaining = recentSearchTerms.filter(function (term) {
      return term !== termToRemove;
    });
    localStorage.setItem(RECENT_SEARCH_TERMS_KEY, JSON.stringify(remaining));
    setRecentSearchTerms(remaining);
  }

  useEffect(function () {
    getRecentSearches();
  }, [getRecentSearches]);

  if (autocompleteItems !== null && autocompleteItems !== void 0 && autocompleteItems.length) {
    var trendingSearchTerms = getTrendingSearchTerms(autocompleteItems);
    var suggestedSearchTerms = getSuggestedSearchTerms(autocompleteItems);

    if (!recentSearchTerms.length && trendingSearchTerms !== null && trendingSearchTerms !== void 0 && trendingSearchTerms.data.length) {
      return renderSearchSuggestions(trendingSearchTerms, getItemProps, getSectionProps);
    }

    if (suggestedSearchTerms !== null && suggestedSearchTerms !== void 0 && suggestedSearchTerms.data.length) {
      return renderSearchSuggestions(suggestedSearchTerms, getItemProps, getSectionProps);
    }
  }

  if (recentSearchTerms.length > 0) {
    return ___EmotionJSX(RecentSearchTerms, {
      recentSearchTerms: recentSearchTerms,
      clearAll: clearAll,
      clearItem: clearItem
    });
  }

  return null;
};